module.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}"


//////////////////
// WEBPACK FOOTER
// /workspace/ckeditor5/node_modules/postcss-loader/lib??ref--1-1!../ckeditor5-heading/theme/heading.css
// module id = 57
// module chunks = 0